var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.hasChild != null ? 'main' : 'main right-big'},[_c('LeftMenu',{on:{"selectMenu":_vm.selectMenuFunc,"selectMenuPath":_vm.selectMenuPath}}),_vm._v(" "),(_vm.showf)?_c('RightContent'):_vm._e(),_vm._v(" "),(!_vm.showf)?_c('RightContentb'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9338af62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/main.vue
// module id = null
// module chunks = 